var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{class:_vm.$route.meta.className || ''},[_c('app-transition',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('bottom-bar',{attrs:{"active":_vm.$route.meta.bottomBar}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }